import React from 'react';
import { Provider } from 'react-redux';
import { StyleRoot } from 'radium';
import App from '../App';
import AppIntl from '../AppIntl';
import AppStyles from '../AppStyles';
import AppStylesRTL from '../AppStylesRTL';

export default function AppRootProd({ store }) {
  return (
    <Provider store={store}>
      <StyleRoot>
        <AppStyles />
        <AppStylesRTL />
        <AppIntl>
          <App />
        </AppIntl>
      </StyleRoot>
    </Provider>
  );
}

AppRootProd.propTypes = {
  store: Provider.propTypes.store,
};
